import React from 'react';
import { FeedbackButtonContainer } from './FeedbackButton.styles';
import { handleInteraction } from './utils/handleInteraction';

interface FeedbackButtonProps {
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export const FeedbackButton = ({
  ariaLabel,
  children,
  className,
  disabled = false,
}: FeedbackButtonProps) => {
  return (
    <FeedbackButtonContainer
      onClick={handleInteraction}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleInteraction(e);
        }
      }}
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
    >
      {children}
    </FeedbackButtonContainer>
  );
};
